namespace TabAurous.Production {
    export namespace JobWorkIssueBOMService {
        export const baseUrl = 'Production/JobWorkIssueBOM';

        export declare function Create(request: Serenity.SaveRequest<JobWorkIssueBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<JobWorkIssueBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<JobWorkIssueBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<JobWorkIssueBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Production/JobWorkIssueBOM/Create",
            Update = "Production/JobWorkIssueBOM/Update",
            Delete = "Production/JobWorkIssueBOM/Delete",
            Retrieve = "Production/JobWorkIssueBOM/Retrieve",
            List = "Production/JobWorkIssueBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>JobWorkIssueBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
